module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-infiniti.c3cb30d0.png";